import { defineComponent } from "vue";
import RouterLinkComponent from "@app/components/UI/LinkElements/RouterLink.vue";
import HtmlLinkComponent from "@app/components/UI/LinkElements/HtmlLink.vue";
import { prefetch } from "@app/router/prefetcher";
export default defineComponent({
    props: {
        link: {
            type: String,
            required: true
        },
        newWindow: {
            type: Boolean,
            default: false
        },
        activeClass: {
            type: String,
            default: null
        },
        exactActiveClass: {
            type: String,
            default: null
        }
    },
    components: {
        RouterLinkComponent,
        HtmlLinkComponent
    },
    computed: {
        domain() {
            return window.location.protocol + "//" + window.location.hostname;
        },
        isExternal() {
            return this.$helpers.isExternalLink(this.link);
        },
        href() {
            let href = "";
            if (this.link.indexOf(this.domain) !== -1) {
                // Internal absolute
                href = this.link.replace(this.domain, "");
            }
            else {
                href = this.link;
            }
            if (href == "//" || href.length == 0) {
                href = "/";
            }
            return href;
        },
        target() {
            return this.isExternal || this.newWindow ? "_blank" : "_self";
        }
    },
    mounted() {
        if (!this.isExternal) {
            const anchorElement = this.$refs.routerLink.$el;
            anchorElement.addEventListener('mouseover', () => prefetch(anchorElement.href), { once: true });
        }
    }
});
